import { defineComponent as o, createBlock as r, openBlock as c, unref as p, mergeProps as m, withCtx as s, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconSunFace",
  __name: "IconSunFace",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (l, t) => (c(), r(p(i), m(n, { "view-box": "0 0 48 48" }), {
      default: s(() => t[0] || (t[0] = [
        e("g", { "clip-path": "url(#72wasa)" }, [
          e("path", { d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48m3.3 9.336c1.044-.168 2.172 1.38 2.52 3.444.348 2.064-.204 3.888-1.2 4.044-.996.156-2.172-1.38-2.52-3.444-.348-2.064.168-3.876 1.2-4.044m-7.116.9c1.056 0 1.956 1.656 1.992 3.756.036 2.1-.78 3.816-1.836 3.84-1.056.024-1.944-1.668-1.98-3.768-.036-2.1.768-3.804 1.824-3.828m14.316 8.58a13.416 13.416 0 0 1-3.804 3.192 15.334 15.334 0 0 1-2.292 1.068 17.334 17.334 0 0 1-2.46.672 16.152 16.152 0 0 1-9.864-1.284.455.455 0 0 1-.216-.624.493.493 0 0 1 .576-.24 17.869 17.869 0 0 0 9.18.588 17.222 17.222 0 0 0 4.308-1.524c1.38-.7 2.682-1.54 3.888-2.508a.492.492 0 0 1 .672.072.456.456 0 0 1 .012.588" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "72wasa" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
